module.exports = __webpack_public_path__ + "static/media/display_yellow.a0645e6e.png";